import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { deepExtract } from 'helpers/deep';
export var SHOW_SELF_SERVE = 'classpass/Cancel/SHOW_SELF_SERVE';
export var SHOW_CANCEL_FORM = 'classpass/Cancel/SHOW_CANCEL_FORM';
export var showSelfServe = function showSelfServe() {
  return {
    type: SHOW_SELF_SERVE
  };
};
export var showCancelForm = function showCancelForm() {
  return {
    type: SHOW_CANCEL_FORM
  };
};
export var selectIsSelfServe = deepExtract.bind(null, 'features.cancel.isSelfServe');
export var selectIsCancelForm = deepExtract.bind(null, 'features.cancel.isCancelForm');
var initialState = {
  isSelfServe: false,
  isCancelForm: false
};
export function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SHOW_SELF_SERVE:
      return _objectSpread({}, state, {
        isSelfServe: true
      });

    case SHOW_CANCEL_FORM:
      return _objectSpread({}, state, {
        isCancelForm: true
      });

    default:
      return state;
  }
}